import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import BillingOrgContractDetailPage from './BillingOrgContractDetailPage'
import BillingOrgContractListPage from './BillingOrgContractListPage'

export default function BillingOrgManagementPage() {
  return (
    <Routes>
      <Route index element={<BillingOrgContractListPage />} />
      <Route path="contracts/:contractId" element={<BillingOrgContractDetailPage />} />
      <Route path="*" element={<Navigate to="/subscriptions/orgs" replace />} />
    </Routes>
  )
}
